import {
  SET_CUSTOM_LONG_LOAD_PAGE_MESSAGE,
  SET_SHOW_LONG_LOAD_PAGE_MESSAGE,
} from '../actions/LongLoadPageActions';

const initialState = {
  showMessage: false,
  customMessage: '',
};

const longLoadPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOW_LONG_LOAD_PAGE_MESSAGE: {
      const { flag } = action.payload;

      return { ...state, showMessage: flag };
    }

    case SET_CUSTOM_LONG_LOAD_PAGE_MESSAGE: {
      const { message } = action.payload;

      return { ...state, customMessage: message };
    }

    default:
      return state;
  }
};

export default longLoadPageReducer;
